module.exports = __webpack_public_path__ + "static/averta-regular-cb3ee073c24058f95b64b62ae97aabc5.woff";